export default __webpack_public_path__ + "static/media/dollar_coin_bronze.f0aa3f86.png";